import axiosInstance from './axiosInstance';

import type { Response } from './axiosInstance';

type VibrationDataResponse = {
    vibrationData: string;
    arrowCommand: string;
}

export const getVibrationData = async (path: string, level: number): Promise<Response<VibrationDataResponse> | undefined> => {
    try {
        const response = await axiosInstance.get<Response<VibrationDataResponse>>(`/jsmol/getVibrationData`, {
            params:{
                path: encodeURIComponent(path),
                level: level
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return undefined;
    }
};

export type GUIOptions = {
    "vibration": {
        "levels": number,
    }
}

export const getGUIOptions = async (path: string): Promise<Response<GUIOptions> | undefined> => {
    try {
        const response = await axiosInstance.get<Response<any>>('/jsmol/options', {
            params: {
                path: encodeURIComponent(path)
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return undefined;
    }
};         
